import React, { useEffect, useState } from "react";
import Axios from "../../../axios/axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import SupplierNavbar from "../Admin/SuppplierNavbar";
import SupplierSidebar from "../Admin/SupplierSidebar";

function CreateBldProduct() {
  const [formData, setFormData] = useState({
    meterialName: "",
    partNo: "",
    meterialcode: "",
    modelId: "",
    brandId: "",
    categoryId: "",
    regionId: "",
    productType: [],
    year: "",
    pricePerUnit: "",
    weightPerUnit: "",
    photos: [],
    manufacturer: "",
    supplier: {
      supplierId: "",
      name: "",
      location: "",
      contactNumber: "",
      email: "",
      description: "",
    },
    features: [],
    application: [],
    handlingInstructions: "",
    newFeature: "",
    newApplication: "",
  });

  const [Materialbrands, setMaterialbrand] = useState([]);
  const [Materalcategories, setMaterialcategory] = useState([]);
  const [Materialmodels, setMaterialModels] = useState([]);
  const [Materialregions, setMaterialRegions] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [productType, setProductTypeList] = useState([]);
  const [selectedType, setSelectedType] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [suppliers, setSupplier] = useState([]);
  const [errorFeature, setErrorFeature] = useState("");
  const [errorApplication, setErrorApplication] = useState("");
  const [manufacturers, setManufacturers] = useState([]);

  const [sidebarOpen, setSidebarOpen] = useState(true);

  useEffect(() => {
    const storedSupplier = sessionStorage.getItem("supplierInfo");
    if (storedSupplier) {
      const supplierInfo = JSON.parse(storedSupplier);
      setSupplier(supplierInfo);
    }
  }, []);

  useEffect(() => {
    getCompleteData();
    fetchRegions();
    fetchSuppliers();
    fetchProductType();
    fetchManufacturers();
  }, []);

  useEffect(() => {
    const fetchLoggedInSupplier = async () => {
      try {
        const supplierInfo = JSON.parse(sessionStorage.getItem("supplierInfo"));

        if (!supplierInfo?.supplierId) {
          console.error("No supplier ID found in session");
          toast.error("Supplier information not found");
          return;
        }

        const response = await Axios.get(
          `/supplier/get/${supplierInfo.supplierId}`
        );
        const apiData = response.data?.data;

        if (!apiData) {
          throw new Error("No supplier data returned from API");
        }

        setFormData((prev) => ({
          ...prev,
          supplier: {
            supplierId: apiData._id,
            name: apiData.supplierName || "",
            location: apiData.address || "",
            contactNumber: apiData.phoneNumber || "",
            email: apiData.emailAddress || "",
            description: apiData.description || "",
          },
          selectedSupplier: apiData,
        }));
      } catch (error) {
        console.error("Error fetching supplier:", error);
        toast.error("Failed to load supplier information");
      }
    };

    fetchLoggedInSupplier();
  }, []);

const fetchManufacturers = async () => {
  try {
    const response = await Axios.get("/manufacturer");
    setManufacturers(response.data); 
  } catch (error) {
    console.error("Error fetching manufacturers:", error.message);
    toast.error("Failed to load manufacturers");
  }
};


  const getCompleteData = async () => {
    try {
      const response = await Axios.get("/type-based-details");
      setMaterialModels(response.data.building?.models || []);
      setMaterialbrand(response.data.building?.brands || []);
      setMaterialcategory(response.data.building?.categories || []);
    } catch (error) {
      console.error("Error fetching parts:", error);
      toast.error("Failed to load material data");
    }
  };

  const fetchRegions = async () => {
    try {
      const response = await Axios.get("/regions");
      setMaterialRegions(response.data || []);
    } catch (error) {
      console.error("Error fetching regions:", error.message);
      toast.error("Failed to load regions");
    }
  };

  const fetchSuppliers = async () => {
    try {
      const response = await Axios.get("/supplier");
      setSupplier(response.data.data || []);
    } catch (error) {
      console.error("Error fetching suppliers:", error.message);
      toast.error("Failed to load suppliers");
    }
  };

  const fetchProductType = async () => {
    try {
      const response = await Axios.get("/type-based-details");
      if (response.data) {
        const formattedTypes = Object.keys(response.data).map((type) => {
          if (type === "engineering") return "Engineering";
          if (type === "building") return "Building";
          if (type === "spare") return "Auto-Spare";
          return type;
        });
        setProductTypeList(formattedTypes);
      }
    } catch (error) {
      console.error("Error fetching product type:", error);
      setProductTypeList([]);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleChange = (e) => {
    setSelectedType(e.target.value);
    setFormData((prev) => ({
      ...prev,
      productType: [e.target.value],
    }));
  };

  const handleFileUpload = async (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;

    setUploading(true);

    try {
      const uploadedPhotos = await Promise.all(
        Array.from(files).map(async (file) => {
          const formData = new FormData();
          formData.append("image", file);

          const config = {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          };

          const { data } = await Axios.post(
            "/upload-multiple",
            formData,
            config
          );
          return {
            title: file.name,
            url: data.fileUrls[0],
          };
        })
      );

      setFormData((prev) => ({
        ...prev,
        photos: [...prev.photos, ...uploadedPhotos],
      }));
      toast.success("Images uploaded successfully");
    } catch (error) {
      console.error("Error uploading images:", error);
      toast.error("Failed to upload images");
    } finally {
      setUploading(false);
    }
  };

  const removePhoto = (index) => {
    setFormData((prev) => {
      const updatedPhotos = [...prev.photos];
      updatedPhotos.splice(index, 1);
      return { ...prev, photos: updatedPhotos };
    });
  };

  const handleAddFeature = () => {
    if (!formData.newFeature.trim()) {
      setErrorFeature("Enter something"); // Show error if input is empty
      return;
    }

    setFormData((prev) => ({
      ...prev,
      features: [...prev.features, formData.newFeature],
      newFeature: "",
    }));

    setErrorFeature(""); // Clear error after adding
  };

  const handleRemoveFeature = (index) => {
    setFormData((prev) => ({
      ...prev,
      features: prev.features.filter((_, i) => i !== index),
    }));
  };

  const handleAddApplication = () => {
    if (!formData.newApplication.trim()) {
      setErrorApplication("Enter something"); // Show error if input is empty
      return;
    }

    setFormData((prev) => ({
      ...prev,
      application: [...prev.application, formData.newApplication],
      newApplication: "",
    }));

    setErrorApplication(""); // Clear error after adding
  };

  const handleRemoveApplication = (index) => {
    setFormData((prev) => ({
      ...prev,
      application: prev.application.filter((_, i) => i !== index),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Prepare the complete data to send
      const submissionData = {
        ...formData,
        supplier: {
          supplierId: formData.selectedSupplier._id,
          name: formData.selectedSupplier.supplierName,
          location: formData.selectedSupplier.address,
          contactNumber: formData.selectedSupplier.phoneNumber,
          email: formData.selectedSupplier.emailAddress,
        },
      };

      const response = await Axios.post("/meterial/create", submissionData);
      toast.success("Material created successfully");
      setTimeout(() => {
        navigate("/SupplierProducts");
      }, 1000);
    } catch (error) {
      console.error("Error creating material:", error);
      toast.error(error.response?.data?.message || "Failed to create material");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="enhanced-body">
      <SupplierNavbar
        supplier={suppliers}
        setSupplier={setSupplier}
        toggleSidebar={() => setSidebarOpen(!sidebarOpen)}
      />

      <div className="container-fluid">
        <div className="row">
          {sidebarOpen && (
            <div className="col-md-2">
              <SupplierSidebar />
            </div>
          )}
          <div className={sidebarOpen ? "col-md-10" : "col-md-12"}>
            <div className="row">
              <div className="col-12 grid-margin stretch-card">
                <div
                  className="card"
                  style={{
                    maxHeight: "95vh",
                    overflowY: "auto",
                    minHeight: "90vh",
                  }}
                >
                  <div className="card-body">
                    <h4 className="card-title">Create Material</h4>
                    <form className="forms-sample" onSubmit={handleSubmit}>
                      {/* Basic Information */}
                      <div className="form-group">
                        <label>Material Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="meterialName"
                          value={formData.meterialName}
                          onChange={handleInputChange}
                          required
                        />
                      </div>

                      <div className="form-group">
                        <label>Part Number</label>
                        <input
                          type="text"
                          className="form-control"
                          name="partNo"
                          value={formData.partNo}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label>Description</label>
                        <textarea
                          className="form-control"
                          name="description"
                          value={formData.description}
                          onChange={handleInputChange}
                          required
                        />
                      </div>

                      <div className="form-group">
                        <label>Material Code</label>
                        <input
                          type="text"
                          className="form-control"
                          name="meterialcode"
                          value={formData.meterialcode}
                          onChange={handleInputChange}
                          required
                        />
                      </div>

                      {/* Dropdown Selections */}
                      <div className="form-group">
                        <label>Brand</label>
                        <select
                          name="brandId"
                          className="form-control"
                          value={formData.brandId}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Select Brand</option>
                          {Materialbrands.map((brand) => (
                            <option key={brand._id} value={brand._id}>
                              {brand.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="form-group">
                        <label>Model</label>
                        <select
                          name="modelId"
                          className="form-control"
                          value={formData.modelId}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Select Model</option>
                          {Materialmodels.map((model) => (
                            <option key={model._id} value={model._id}>
                              {model.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="form-group">
                        <label>Category</label>
                        <select
                          name="categoryId"
                          className="form-control"
                          value={formData.categoryId}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Select Category</option>
                          {Materalcategories.map((category) => (
                            <option key={category._id} value={category._id}>
                              {category.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="form-group">
                        <label>Region</label>
                        <select
                          name="regionId"
                          className="form-control"
                          value={formData.regionId}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Select Region</option>
                          {Materialregions.map((region) => (
                            <option key={region._id} value={region._id}>
                              {region.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="form-group">
                        <label>Product Type</label>
                        <select
                          className="form-control"
                          value={selectedType}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Select Product Type</option>
                          {productType.map((type) => (
                            <option key={type} value={type}>
                              {type}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Specifications */}
                      <div className="form-group">
                        <label>Year</label>
                        <input
                          type="number"
                          className="form-control"
                          name="year"
                          value={formData.year}
                          onChange={handleInputChange}
                          required
                        />
                      </div>

                      <div className="form-group">
                        <label>Price Per Unit</label>
                        <input
                          type="number"
                          className="form-control"
                          name="pricePerUnit"
                          value={formData.pricePerUnit}
                          onChange={handleInputChange}
                          required
                        />
                      </div>

                      <div className="form-group">
                        <label>Weight Per Unit</label>
                        <input
                          type="number"
                          className="form-control"
                          name="weightPerUnit"
                          value={formData.weightPerUnit}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label>Manufacturer</label>
                        <select
                          name="manufacturer"
                          className="form-control"
                          value={formData.manufacturer}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Select Manufacturer</option>
                          {manufacturers.map((manufacturer) => (
                            <option
                              key={manufacturer._id}
                              value={manufacturer._id}
                            >
                              {manufacturer.manufacturerName}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="form-group">
                        <label>Handling Instructions</label>
                        <textarea
                          className="form-control"
                          name="handlingInstructions"
                          value={formData.handlingInstructions}
                          onChange={handleInputChange}
                          required
                        />
                      </div>

                      {/* Features Section */}
                      <div className="form-group">
                        <label>Features</label>
                        <div className="d-flex mb-2">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Add Feature"
                            value={formData.newFeature}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                newFeature: e.target.value,
                              });
                              setErrorFeature(""); // Clear error on typing
                            }}
                          />
                          {errorFeature && (
                            <p className="text-danger mt-1">{errorFeature}</p>
                          )}

                          <button
                            type="button"
                            className="btn btn-primary ms-2"
                            onClick={handleAddFeature}
                          >
                            Add
                          </button>
                        </div>
                        <div className="d-flex flex-wrap gap-2">
                          {formData.features.map((feature, index) => (
                            <div
                              key={index}
                              className="badge bg-primary d-flex align-items-center"
                            >
                              {feature}
                              <button
                                type="button"
                                className="btn-close btn-close-white ms-2"
                                onClick={() => handleRemoveFeature(index)}
                                aria-label="Remove"
                              />
                            </div>
                          ))}
                        </div>
                      </div>

                      {/* Applications Section */}
                      <div className="form-group">
                        <label>Applications</label>
                        <div className="d-flex mb-2">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Add Application"
                            value={formData.newApplication}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                newApplication: e.target.value,
                              });
                              setErrorApplication(""); // Clear error on typing
                            }}
                          />
                          {errorApplication && (
                            <p className="text-danger mt-1">
                              {errorApplication}
                            </p>
                          )}

                          <button
                            type="button"
                            className="btn btn-primary ms-2"
                            onClick={handleAddApplication}
                          >
                            Add
                          </button>
                        </div>
                        <div className="d-flex flex-wrap gap-2">
                          {formData.application.map((app, index) => (
                            <div
                              key={index}
                              className="badge bg-success d-flex align-items-center"
                            >
                              {app}
                              <button
                                type="button"
                                className="btn-close btn-close-white ms-2"
                                onClick={() => handleRemoveApplication(index)}
                                aria-label="Remove"
                              />
                            </div>
                          ))}
                        </div>
                      </div>

                      {/* Photos Upload */}
                      <div className="form-group">
                        <label>Photos</label>
                        <input
                          type="file"
                          className="form-control"
                          onChange={handleFileUpload}
                          multiple
                          accept="image/*"
                        />
                        {uploading && (
                          <div
                            className="spinner-border spinner-border-sm mt-2"
                            role="status"
                          >
                            <span className="visually-hidden">
                              Uploading...
                            </span>
                          </div>
                        )}
                        <div className="d-flex flex-wrap gap-2 mt-2">
                          {formData.photos.map((photo, index) => (
                            <div key={index} className="position-relative">
                              <img
                                src={photo.url}
                                alt={photo.title}
                                className="img-thumbnail"
                                style={{ height: "100px", width: "auto" }}
                              />
                              <button
                                type="button"
                                className="btn btn-danger btn-sm position-absolute top-0 end-0"
                                onClick={() => removePhoto(index)}
                              >
                                ×
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>

                      {/* Supplier */}
                      <div className="form-group">
                        <label>Supplier</label>
                        <input
                          type="text"
                          className="form-control mt-2"
                          value={
                            formData.selectedSupplier?.supplierName ||
                            "Loading..."
                          }
                          placeholder="Supplier Name"
                          readOnly
                        />
                      </div>

                      {/* Submit Button */}
                      <button
                        type="submit"
                        className="btn btn-primary me-2"
                        disabled={loading || uploading}
                      >
                        {loading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-1"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Creating...
                          </>
                        ) : (
                          "Create Material"
                        )}
                      </button>
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => navigate("/SupplierProducts")}
                      >
                        Cancel
                      </button>
                      <div style={{ marginBottom: "60px" }}></div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateBldProduct;
